<div class="container-fluid">
    <div class="row">
        <div class="col">
            <h2 mat-dialog-title>{{title}}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <mat-dialog-content>
                <p>{{body}}</p>
            </mat-dialog-content>
        </div>
    </div>
    <div class="row">
        <mat-dialog-actions>
            <div class="col-2">
                <button mat-raised-button (click)="close(okayButtonText)">{{okayButtonText}}</button>
            </div>
            <div *ngIf="isOtherButtonVisible" class="col-2">
                <button mat-raised-button (click)="close(otherButtonText)" color="warn">{{otherButtonText}}</button>
            </div>
        </mat-dialog-actions>
    </div>
</div>